export const validateEmptyArrays = (arrayDescriptors) => {
  arrayDescriptors.forEach((arrayDescriptor) => {
    if (!arrayDescriptor.array.length)
      throw {
        name: 'EmptyArray',
        message: `You must select at least one ${arrayDescriptor.nameSingular}`,
      };
  });
};

export const createArrayDescriptor = (array = [], nameSingular = 'entityInSingular') => ({
  array,
  nameSingular,
});
